<router-outlet></router-outlet>

@if (showTimeoutModal()) {
  <app-session-dialog
    (onExitClicked)="logout()"
    (onRefreshClicked)="refreshToken()"
    [loading]="isProcessingInactivity()"
  ></app-session-dialog>
}
